import styles from "./ProgressCircle.module.scss";

export default function ProgressCircle({
  size,
  progress = 0,
  color = "blue",
}: {
  size?: number;
  progress?: number;
  color?: "blue" | "green" | "yellow" | "red";
}) {
  const circleSize = size || 16;
  const style = {
    "--progress": Math.round(progress * 100),
    "--size": circleSize + "px",
  } as React.CSSProperties;

  const cssColor = {
    blue: "#5394fd",
    green: "#52C41A",
    yellow: "#FAAD14",
    red: "red",
  };

  return (
    <svg
      width={`${circleSize}`}
      height={`${circleSize}`}
      viewBox={`0 0 ${circleSize} ${circleSize}`}
      className={styles["circular-progress"]}
      style={style}
    >
      <circle className={styles.bg}></circle>
      <circle
        className={styles.fg}
        style={{ stroke: cssColor[color] }}
      ></circle>
    </svg>
  );
}
